import { CheckmarkCircleOutlineIcon } from '@carboncopyco/icons';
import { ColorHex, TextBase } from '@carboncopyco/ui';

type CompletedStepsProps = {
  completedSteps: number;
  stepsCount: number;
};

export const CompletedStepsCol = ({
  completedSteps,
  stepsCount,
}: CompletedStepsProps) => (
  <div className="flex items-center gap-2 truncate text-ds-natural-300">
    <TextBase
      label={`${completedSteps}/${stepsCount}`}
      color={
        completedSteps < stepsCount
          ? 'text-ds-natural-300'
          : 'text-ds-accent2-400'
      }
    />
    <div
      className={`${completedSteps < stepsCount ? 'invisible' : 'visible'}  `}
    >
      <CheckmarkCircleOutlineIcon
        size={18}
        color={ColorHex.accent2400}
      />
    </div>
  </div>
);
